import React from "react";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';

const TauriBreadcrumbHeadingTitle = ({ paths, handleOnclick, separator }) => {
    return (
        <Breadcrumb className="tauri-breadcrumbs d-none d-xl-block">
            {paths.map((data, index) => (
                <React.Fragment key={index}>
                    <Breadcrumb.Item active={index === paths.length - 1}>
                        {index === paths.length - 1 ? (
                            <div className='item-breadcrumbs'>
                                {data.icon && <img src={`${process.env.PUBLIC_URL}${data.icon}`} alt="Icon" />}
                                <span className='active-item text-dark'>{data.name}</span>
                            </div>
                        ) : (
                            <Link to={data.path} onClick={() => handleOnclick(data.path)} className='item-breadcrumbs'>
                                {data.icon && <img src={`${process.env.PUBLIC_URL}${data.icon}`} alt="Icon" />}
                                {data.name}
                            </Link>
                        )}
                    </Breadcrumb.Item>
                    {index < paths.length - 1 && (
                        <span className="separator">{separator}</span>
                    )}
                </React.Fragment>
            ))}
        </Breadcrumb>
    )
}

export default TauriBreadcrumbHeadingTitle